import auth from './auth'

import {
  AppRoute,
} from '@kaidam/fc-shared/src/types/frontend/router'

import {
  RootState,
} from '../types/store'

const routes: AppRoute<RootState>[] = [
  {
    name: 'notfound',
    path: '/notfound',
    meta: {
      showManage: true,
    }
  },
  {
    name: 'home',
    path: '/',
    meta: {
      showManage: true,
    }
  },
  {
    name: 'pay',
    path: '/pay',
  },
  {
    name: 'register_interest',
    path: '/register_interest',
  },
  {
    name: 'pay_confirm',
    path: '/pay_confirm',
    meta: {
      showManage: true,
    }
  },
  {
    name: 'booking',
    path: '/booking/:orgid',
    children: [{
      name: 'welcome',
      path: '/welcome',
      meta: {
        showSteps: false,
        showManage: true,
      }
    }, {
      name: 'product',
      path: '/product',
      meta: {
        showSteps: true,
        showManage: true,
      }
    }, {
      name: 'calendar',
      path: '/calendar',
      meta: {
        showSteps: true,
        showManage: true,
      }
    }, {
      name: 'details',
      path: '/details',
      meta: {
        showSteps: true,
        showManage: true,
      }
    }, {
      name: 'payment',
      path: '/payment',
      meta: {
        showSteps: true,
        showManage: true,
        bookingSummaryTitle: 'Review your booking and proceed to payment'
      }
    }, {
      name: 'payment_confirm',
      path: '/payment_confirm',
      meta: {
        showSteps: true,
        showManage: true,
      }
    }]
  },
  {
    name: 'login',
    path: '/manage_login',
  },
  {
    name: 'manage',
    path: '/manage/:orgid',
    children: [{
      name: 'booking',
      path: '/booking',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'payments',
      path: '/payments',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'details',
      path: '/details',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'presurvey',
      path: '/presurvey',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'postsurvey',
      path: '/postsurvey',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'monthfeedback',
      path: '/monthfeedback',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }, {
      name: 'yearfeedback',
      path: '/yearfeedback',
      meta: {
        showTabs: true,
        showLogout: true,
      }
    }]
  },
]

export default routes